export default __webpack_public_path__ + "static/topNavItems-anatomy-dark-058913f1c009a9862671bf70f6727677.png";